<template>
  <div class="rent">
<!--  	<p style="height:50px;background:#666;">数据库的时间回复可见的可正对面</p>-->
    <div style="height:12rem">
      <swiper :options="swiperOption" class="swiper-box">
        <swiper-slide class="swiper-item" v-for="(img,idx) in annexInfo" :key="idx"><img :src='img' /></swiper-slide>
 
        <div class="swiper-pagination swiper-pagination-btn" slot="pagination"></div>
      </swiper>
    </div>

    <div class="list-title">
      <ul class="ui-list ">
        <li class="title-name">{{title}}</li>
        <li class="community-name">{{communityName}}</li>
        <li>
          <div class="ui-pay-info">
            <ul class="payway">
              <li>付款方式</li>
              <li>{{ payType }}</li>
            </ul>
            <div class="floor-info">{{ floor }}楼</div>
          </div>
  
        </li>
      </ul>
    </div>

    <div class="room" v-for="(room,index) in roomsList" :key="'roomsList'+index" v-show="roomsList.length > 0">
      <div class="houseRoomRented" v-if="room.rentStatus === 2">
        <div class="backViewRented">
          <div class="titleAreaRented">
            <div class="roomNameTitleRented">
              {{ room.roomName }}
            </div>
            <div class="statusRented">
              已出租
            </div>
          </div>
          <div class="rentDescRented">
            {{ room.renterDescrption }}
          </div>
        </div>
      </div>
      <div class="houseRoomOpen" v-if="room.rentStatus === 1">
        <div class="titleAreaOpen">
          <div class="titleOpen">
            {{ room.roomName }}
          </div>
        </div>
        <div class="servicesItemsOpen">
          <div class="serviceItemOpen" v-for="(item,idx) in room.deviceName" :key="idx">
            {{ item }}
          </div>
          
        </div>
        <div class="separatorLineOpen"></div>
        <div class="roomAreaAndPriceOpen">
          <div class="roomAreaOpen">
            {{room.roomArea}}平方米
          </div>
          <div class="rentalPriceOpen">
            {{room.rental}}元/月
          </div>
        </div>
      </div>
    </div>

    <div class="devices" v-for="(facilityItem, index) in facilitesInfo" :key="index">
      <site-services-item 
        :title="facilityItem.roomName"
        :items="facilityItem.deviceName"
        :richText="facilityItem.richText ? facilityItem.richText : false"
      >
      </site-services-item>
    </div>
     <!--悬浮在底部的按钮-->
     <!--<div class="btn-suspension" styel="display: none;"><img class="icon"src="../assets/image/icon-phone.png" ><span>我要看房</span></div>-->
  </div>
</template>

<script>
import api from '@/script/util'
import { swiper, swiperSlide, swiperPlugins } from 'vue-awesome-swiper'
import SiteServicesItem from './siteServicesItem.vue'
import '@/style/base.css'
export default {
  name: '', // 租房详情
  components: {
    swiper,
    swiperSlide,
    swiperPlugins,
    'site-services-item': SiteServicesItem
  },
  data () {
    return {
      annexInfo: [],
      title: '',
      communityName: '',
      payType: '',
      floor: '8',
      roomsList: [],
      facilitesInfo: [],
      around_match: '',
      swiperOption: {
        // 如果你后续需要找到当前实例化后的swiper对象以对其进行一些操作的话，可以自定义配置一个名字
        name: 'currentSwiper',
        // 所有配置均为可选（同Swiper配置）
        autoplay: 3000,
        direction: 'horizontal',
        pagination: '.swiper-pagination',
        paginationType: 'fraction',
        paginationClickable: true,
        mousewheelControl: true,
        observeParents: true
      }
    }
  },
  mounted () {
    document.title = '详情'
    var params = {
      id: api.getVal('id')
    }
    api.GetRentDetailsInfo(params)
      .then(res => {
        console.log(res)
        this.annexInfo = res.annexInfo
        this.title = res.title
        this.communityName = res.communityName
        this.payType = res.payType
        this.floor = res.floor

        console.log('res.saloonList', JSON.stringify(res.saloonList))

        this.facilitesInfo = []
        this.facilitesInfo = this.facilitesInfo.concat(res.saloonList)
        this.facilitesInfo = this.facilitesInfo.concat(res.kitchenList)
        this.facilitesInfo = this.facilitesInfo.concat(res.toiletList)

        this.roomsList = res.roomsList

        this.around_match = (res.aroundMatch === '<style>p{text-indent: 0 !important;}</style><p></p>' ? '' : res.aroundMatch)

        if (this.around_match) {
          let aroundMatch = {}
          aroundMatch.roomName = '周边配套'
          aroundMatch.deviceName = [this.around_match]
          aroundMatch.richText = true
          this.facilitesInfo.push(aroundMatch)
        }
      })
  },
  methods: {
    onSlideChangeStart (currentPage) {
      console.log('onSlideChangeStart', currentPage)
    },
    onSlideChangeEnd (currentPage) {
      console.log('onSlideChangeEnd', currentPage)
    },
    splitArray (array, size) {
      var result = []
      for (var x = 0; x < Math.ceil(array.length / size); x++) {
        var childlist = []
        var start = x * size
        var end = start + size
        childlist = array.slice(start, end)
        result.push(childlist)
        if (childlist.length < size) {
          for (var i = 0; i <= size - childlist.length; i++) {
            childlist.push('')
          }
        }
      }
      return result
    },
    getDeviceList (object) {
      if (JSON.stringify(object) !== '{}') {
        if (window.devicePixelRatio > 2) {
          object.deviceName = this.splitArray(object.deviceName, 4)
        } else {
          object.deviceName = this.splitArray(object.deviceName, 3)
        }
      }
    }
  }
}
</script>


<style lang="scss">
@import '../style/var.scss';
.rent{
  background-color: #F5F5F5;
  height:28.5rem;
}
.swiper-item img {
  width:100%;
  height:auto;
}

.ui-list>li {
  margin-left: 0px !important;
}

.list-title {
  padding: 0.75rem .75rem;
  background-color: #fff;
}

.title-name {
  text-align: -webkit-auto;
}

.community-name {
  padding: 0.5rem 0 0.4rem 0;
  color: #aaaaaa;
  font-size: 0.6rem;
}

.ui-pay-info {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.payway {
  /*width: 5.5rem;*/
  height: 1.4em;
  /*background: url('../assets/image/payType.png') no-repeat;
  background-size:100% 100%;*/
  list-style:none;
  display: flex;
  border: 1px solid #ff6e0b;
  border-radius: 0.15em;

}

.payway>li {
  display: flex;
  width: auto;
  height: 100%;
  text-align: center;
  color: #ff6e0b;
  font-size: 0.5rem;
  justify-content: center;
  align-items: center;
  padding: 0 0.5em;
}

.payway>li:first-child {
  color: #fff;
  background-color: #ff6e0b;
}

.floor-info {
  color: #aaaaaa;
  font-size: 0.6rem;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}


/******房间*****/

.houseRoomRented {
  height: 100%;
  background: white;
}

.backViewRented {
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
  flex-wrap: wrap;
  margin: 0rem 0.64rem 0.64rem 0rem;
}

.titleAreaRented {
  padding: 0.64rem 0rem 0rem 0rem;
  background: white;
  display: flex;
  align-items: center;
}

.roomNameTitleRented {
  font-size: 0.512rem;
  line-height: 1.1947rem;
  color: $button-text-color;
  background: $button-background-color;
  text-align: center;
  min-height: 1.1947rem;
  border-radius: 0rem 0.128rem 0.128rem 0rem;
  padding: 0rem 0.64rem;
}
.statusRented {
  font-size: 0.64rem;
  min-width: 2.0267rem;
  color: #AAAAAA;
  margin-left: 0.4266rem;
}

.rentDescRented {
  background: #f2f2f2;
  border-radius: 0.128rem;
  color: #AAAAAA;
  font-size: 0.512rem;
  line-height: 1.1947rem;
  height: 1.1947rem;
  text-align: center;
  padding: 0rem 0.64rem;
  margin-left: 0.64rem;
  margin-top: 0.64rem;
}


.room {
  margin-top: 0.4267rem;
  background-color: #fff;
  /* padding-top: .75rem; */
  /* display: flex; */
}

.houseRoomOpen {
  height: 100%;
	background: white;
}
.titleAreaOpen {
  padding-top: 0.64rem;
  background: white;
  display: flex;
  align-items: center;
}
.titleOpen {
  font-size: 0.512rem;
  line-height: 1.1947rem;
  color: $button-text-color;
  background: $button-background-color;
  text-align: center;
  height: 1.1947rem;
  border-radius: 0rem 0.128rem 0.128rem 0rem;
  padding: 0rem 0.64rem 0rem 0.64rem;
}
.servicesItemsOpen {
  display: flex;
  justify-items: center;
  width: 100%;
  margin-bottom: 0.8533rem;
  flex-wrap: wrap;
}
.serviceItemOpen {
  width: calc(100% / 3);
  font-size: 0.512rem;
  color: black;
  text-align: center;
  margin-top: 0.8533rem;
}
.separatorLineOpen {
  flex: 1 1 0%;
  height: 0.0427rem;
  margin: 0rem 0.64rem 0rem 0.64rem;
  border-bottom:0.0427rem solid #d8d8d8;
}
.roomAreaAndPriceOpen {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  margin: 0rem 0.64rem 0rem 0.64rem;
}
.roomAreaOpen {
  font-size: 0.64rem;
  line-height: 2.1333rem;
}
.rentalPriceOpen {
  font-size: 0.64rem;
  color: #ff6648;
  line-height: 2.1333rem;
}

.devices {
  padding-top: 0.4267rem;
  width: 100%;
  background: #F5F5F5;
}
</style>



// WEBPACK FOOTER //
// rent.vue?65cd57d7